export class SourceMapper {
  private static displayNameMap: { [key: string]: string } = {
    'TWITTER': 'Twitter (X)',
    'Twitter': 'Twitter (X)',
    'WHATSAPP': 'WhatsApp',
    'WhatsApp': 'WhatsApp',
    'Whatsapp': 'WhatsApp',
    'CALL': 'Call',
    'Call': 'Call',
    'EMAIL': 'Email',
    'Email': 'Email',
    'WEBSITE': 'Website',
    'Website': 'Website',
    'FACEBOOK': 'Facebook',
    'Facebook': 'Facebook',
    'INSTAGRAM': 'Instagram',
    'Instagram': 'Instagram',
    'LINKEDIN': 'LinkedIn',
    'LinkedIn': 'LinkedIn',
    'TIKTOK': 'TikTok',
    'TikTok': 'TikTok'
  };

  private static enumValueMap: { [key: string]: string } = {
    'Twitter (X)': 'TWITTER',
    'Twitter': 'TWITTER',
    'WhatsApp': 'WHATSAPP',
    'Call': 'CALL',
    'Email': 'EMAIL',
    'Website': 'WEBSITE',
    'Facebook': 'FACEBOOK',
    'Instagram': 'INSTAGRAM',
    'LinkedIn': 'LINKEDIN',
    'TikTok': 'TIKTOK',
    'TWITTER': 'TWITTER',
    'WHATSAPP': 'WHATSAPP',
    'Whatsapp': 'WHATSAPP',
    'CALL': 'CALL',
    'EMAIL': 'EMAIL',
    'WEBSITE': 'WEBSITE',
    'FACEBOOK': 'FACEBOOK',
    'INSTAGRAM': 'INSTAGRAM',
    'LINKEDIN': 'LINKEDIN',
    'TIKTOK': 'TIKTOK'
  };

  static toDisplayName(source: string): string {
    if (!source) {
      return source;
    }
    return this.displayNameMap[source] || source;
  }

  static toEnumValue(source: string): string {
    if (!source) {
      return source;
    }
    return this.enumValueMap[source] || source;
  }
}

